module.exports = "<p>\n  company works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /Users/dev-man/Kgwetlwo-app/src/app/pages/company/company/company.component.html
// module id = ../../../../../src/app/pages/company/company/company.component.html
// module chunks = main